import { IconLockCloseFilled } from '@iwoca/icons';
import { Button } from '@iwoca/orion';

import { buildQueryString } from '../../Buyer/utils/queryParams';

export const LockedButton = () => {
  const queryString = buildQueryString();

  return (
    <a href={`/pay/activation/${queryString}`}>
      <Button variant="primary">
        <IconLockCloseFilled />
        Finish setup to unlock
      </Button>
    </a>
  );
};
